export default __webpack_public_path__ + "static/media/mus-prettylittlefears.6cfdb619.mp4";